import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "checkoutButton", "agreeCheckbox" ]

  connect() {
  }

  onChangeAgreement(event) {
    if (event.target.checked) {
      this.checkoutButtonTarget.classList.remove('button-disable')
      this.checkoutButtonTarget.classList.add('button-primary')
      this.checkoutButtonTarget.disabled = false
    } else {
      this.checkoutButtonTarget.classList.add('button-disable')
      this.checkoutButtonTarget.classList.remove('button-primary')
      this.checkoutButtonTarget.disabled = true
    }
  }
}
